import { cloneDeep } from 'lodash';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ProfileHistoryGroup } from '@fry/lib/users';

enum FilterValue {
  CURRENT = 'current',
  PREVIOUS = 'previous',
  FUTURE = 'future',
  ALL = 'all'
}
interface HistoryFilter {
  title: string;
  value: FilterValue;
  isActive: boolean;
}

@Component({
    selector: 'eas-user-history',
    templateUrl: './user-history.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserHistoryComponent implements OnChanges {
  @Input() history: ProfileHistoryGroup[];

  filtered: ProfileHistoryGroup[];
  filters: HistoryFilter[] = [
    {
      title: $localize `Current`,
      value: FilterValue.CURRENT,
      isActive: true
    },
    {
      title: $localize `Previous`,
      value: FilterValue.PREVIOUS,
      isActive: false
    },
    {
      title: $localize `Future`,
      value: FilterValue.FUTURE,
      isActive: false
    },
    {
      title: $localize `All`,
      value: FilterValue.ALL,
      isActive: false
    }
  ];

  ngOnChanges() {
    const { value } = this.getActiveFilter();
    this.setHistory(value);
  }

  formatHistory() {
    const rawHistory = cloneDeep(this.history);
    if (!Array.isArray(rawHistory)) {
      return [];
    }

    const { value: historyFilter } = this.getActiveFilter();

    return rawHistory.reduce((history, curr) => {
      if (historyFilter !== FilterValue.ALL) {
        curr = {
          ...curr,
          history: curr.history.filter(itm => itm.period === historyFilter)
        };
      }

      if (curr.history.length > 0) {
        history.push(curr);
      }

      return history;
    }, []);
  }

  setHistory(value: FilterValue) {
    this.filters = this.setActiveFilter(value);
    this.filtered = this.formatHistory();
  }

  setActiveFilter(value: FilterValue) {
    return this.filters.map(filter =>
      filter.value === value
        ? { ...filter, isActive: true }
        : { ...filter, isActive: false }
    );
  }

  getActiveFilter() {
    return this.filters.find(({ isActive }) => isActive === true);
  }
}
